/* eslint-disable @gandi/gandi/no-global-element */
// @flow
import * as React from 'react';

import capitalize from 'lodash/capitalize';

import type { DecoratedProduct } from '@gandi/cart';

import { useTranslator } from '@gandi/translate';
import { SrOnly } from '@gandi/ui';

import { useConfigurationDetailsUpSell } from '../modules/webhosting';

import { PlanContent } from './PlanContent';

import styles from './PlanRow.scss';

type Props = {
  isSelected: boolean,
  onSelect: (evt: SyntheticInputEvent<>) => void,
  disabled: boolean,
  product: DecoratedProduct,
  value: string,
  price?: string,
  detail?: React.Node,
};

export function PlanRow({
  detail,
  isSelected,
  onSelect,
  disabled,
  product,
  value,
  price,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  // TODO: Move
  const { cpu, storage } =
    useConfigurationDetailsUpSell({
      duration: product.payload.duration || 1,
      // $FlowFixMe[incompatible-call]
      size: value,
    }) || {};

  const options = [storage, cpu];

  const handleClick = (e: SyntheticInputEvent<>) => {
    if (!disabled) {
      onSelect(e);
    }
  };

  const sizeLabel = value === 'essential' ? __('Essential') : capitalize(value);

  return (
    <label
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex="0"
      htmlFor={`plan-${value}-${product.id}`}
      className={styles.root}
    >
      <SrOnly>
        <input
          type="radio"
          id={`plan-${value}-${product.id}`}
          name={`plan-size-${product.id}`}
          value={value}
          checked={isSelected}
          onChange={handleClick}
          disabled={disabled}
          tabIndex="-1"
        />
      </SrOnly>

      <PlanContent
        sizeLabel={sizeLabel}
        price={price}
        detail={detail}
        options={options}
      />
    </label>
  );
}
